<template>
	<div :id="'classified' + data.id" style="padding: 16px;">
		<div class="icoev-date-text"> {{ data.fecha }}</div>
		<h2 class="primary--text icoev-item-title">{{ data.tipo_anuncio }}</h2>
		<p class="mb-2">{{ data.anunciante }}</p>
		<v-divider class="mb-2"></v-divider>
		<div class="text--primary">
			<!--<b v-if="data.tipo_anuncio.startsWith('Oferta')">Se requiere:</b>
			<br v-if="data.tipo_anuncio.startsWith('Oferta')"/>-->
			<span v-html="data.descripcion.replace(/\r\n/g, '<br>')"></span>
		</div>
		<v-divider class="mt-2 mb-2"></v-divider>
		<div class="text--primary">
			<v-list style="padding: 0;">
				<v-list-group class="icoev-list-group">
					<template v-slot:activator>
						<v-list-item style="padding: 0; min-height: 20px;">
							<v-list-item-content style="padding: 0;">
								<v-list-item-title><b>Datos de contacto</b></v-list-item-title>
							</v-list-item-content>
					</v-list-item>
					</template>

					<v-list-item style="min-height: 20px;">
						<v-list-item-content style="padding: 10px 0 0;">
							<v-list-item-title>
								<a class="text--primary" :href="'mailto:' + data.anun_email" style="font-size: 12px; color: #065535 !important; line-height: 15px">
									{{ data.anun_email }}
								</a>
								<p class="mb-0" style="padding-top: 5px; font-size: 12px; line-height: 15px">
									<span v-if="$store.state.icoev.device.platform == 'browser'">Tlf: {{ data.anun_telefono }}</span>
									<span v-if="$store.state.icoev.device.platform != 'browser'">
										Tlf: <a :href="'tel:' + data.anun_telefono">{{ data.anun_telefono }}</a>
									</span>
								</p>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>
			</v-list>
		</div>
	</div>
</template>

<script>
import BaseModule from "./BaseModule";

export default {
	name: 'ClassifiedItem',
	mixins: [ BaseModule ],
	props: [ 'data' ],
	data() {
		return {
		}
	},
}
</script>